// src/lib/feedScroll.js
//
// 031-10: a scroll to the top of a creator's post feed, asked for by a post
// made elsewhere (the navbar's composer, possibly before navigating to the
// creator page). The feed of THAT creator takes it once its cards are loaded
// (PostFeed). Kept outside PostFeed so the navbar doesn't import the feed.
// 032-04: `landAfterPost` is the whole after-post move, shared by the navbar's
// "Post" and the phone More sheet's.

import { resolveKolTab } from './kolTabs';

let pending = null;

export function requestFeedTopScroll(creatorId) { pending = creatorId ?? null; }

/** True once for the creator a scroll was asked for (and forgets it). */
export function takeFeedTopScroll(creatorId) {
  if (!creatorId || pending !== creatorId) return false;
  pending = null;
  return true;
}

/**
 * After a post: the creator's own Posts tab, its feed scrolled to the top (the
 * new card first). Already there: no navigation — the post-created refetch
 * runs and the feed scrolls. No handle: nothing (creator pages are reached by
 * handle).
 */
export function landAfterPost({ creatorProfile, location, navigate }) {
  const handle = creatorProfile?.handle;
  if (!handle) return;
  requestFeedTopScroll(creatorProfile?.creator_id || creatorProfile?.id || null);
  const target = `/creator/${encodeURIComponent(handle)}`;
  let here = false;
  try { here = decodeURIComponent(location?.pathname || '').replace(/\/+$/, '').toLowerCase() === `/creator/${handle}`.toLowerCase(); } catch { /* malformed path */ }
  const onPosts = here && resolveKolTab(new URLSearchParams(location?.search || '').get('tab')) === 'collections';
  if (!onPosts) navigate(`${target}?tab=collections`, here ? { replace: true } : undefined);
}
